import { DbMongoBaseInfos } from "./db-mongo-base-infos";

import { MetadataViewType } from "./metadata-view-type";
import { ObjectLayer } from "./object-layer";
import { ObjectType } from "./object-type";
import { DbMetadataViewGroup } from "./db-metadata-view-group";
import { DbMetadataViewFilter } from "./db-metadata-view-filter";

export class DbMetadataViewInfos extends DbMongoBaseInfos {
  platformId: number | null = 0;
  type: MetadataViewType | null = null;
  objectLayer: ObjectLayer | null = null;
  name: string | null = null;
  objectTypes: ObjectType[] | null = null;
  groups: DbMetadataViewGroup[] | null = null;
  filters: DbMetadataViewFilter[] | null = null;

  constructor(init?: Partial<DbMetadataViewInfos>) {
    super();
    Object.assign(this, init);
  }
}
